// 一些全局的config配置
const modeUrlObj = {
  // 生产环境
  'production': {
    baseURL: 'https://grainservice.club:8443/nongxinle/api/',
    baseURLIMG: 'https://grainservice.club:8443/nongxinle/api/captcha.jpg',
    authBaseURL: '',
    // DeepSeek AI 配置
    deepSeek: {
      apiKey: 'sk-ab54d76efc1e4d95a7ab2cdb3013a920', // 建议从后端获取或使用环境变量
      apiUrl: 'https://api.deepseek.com/v1/chat/completions',
      model: 'deepseek-chat'
    },
    // 腾讯云语音识别配置
    tencentCloud: {
      secretId: 'AKIDvriMo5B4mHYbf9PRHwQgiW6SeeR2QdcO', // Secret ID（通常以 AKID 开头）
      secretKey: 'd3HI5h8LL7j8JG3kGbjgPBnEQPAh181g', // Secret Key
      appId: '1308821743', // 腾讯云账号appid（非微信appid）
      engineModelType: '16k_zh',
      voiceFormat: 1
    }
  },
  // 开发环境
  'development': {
    baseURL: 'http://192.168.0.101:8080/nongxinle_master_war_exploded/api/',
    baseURLIMG: 'http://192.168.0.101:8080/nongxinle_master_war_exploded/api/captcha.jpg',
    authBaseURL: '',
    // DeepSeek AI 配置
    deepSeek: {
      apiKey: 'sk-ab54d76efc1e4d95a7ab2cdb3013a920', // 建议从后端获取或使用环境变量
      apiUrl: 'https://api.deepseek.com/v1/chat/completions',
      model: 'deepseek-chat'
    },
    // 腾讯云语音识别配置
    tencentCloud: {
      secretId: 'AKIDvriMo5B4mHYbf9PRHwQgiW6SeeR2QdcO', // Secret ID（通常以 AKID 开头）
      secretKey: 'd3HI5h8LL7j8JG3kGbjgPBnEQPAh181g', // Secret Key
      appId: '1308821743', // 腾讯云账号appid（非微信appid）
      engineModelType: '16k_zh',
      voiceFormat: 1
    }
  },
  // 测试环境
  'test': {
    baseURL: 'http://localhost:8080/nongxinle_master_war_exploded/',
    authBaseURL: '',
    // DeepSeek AI 配置
    deepSeek: {
      apiKey: 'sk-ab54d76efc1e4d95a7ab2cdb3013a920', // 建议从后端获取或使用环境变量
      apiUrl: 'https://api.deepseek.com/v1/chat/completions',
      model: 'deepseek-chat'
    },
    // 腾讯云语音识别配置
    tencentCloud: {
      secretId: 'AKIDvriMo5B4mHYbf9PRHwQgiW6SeeR2QdcO', // Secret ID（通常以 AKID 开头）
      secretKey: 'd3HI5h8LL7j8JG3kGbjgPBnEQPAh181g', // Secret Key
      appId: '1308821743', // 腾讯云账号appid（非微信appid）
      engineModelType: '16k_zh',
      voiceFormat: 1
    }
  }
}
export default modeUrlObj[process.env.NODE_ENV]
